import React, { useEffect, useState, Fragment } from "react";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import Cookies from "js-cookie";
import { Accordion } from "react-bootstrap";
import "../../Webiste/Components/CSS/pagesCSS/dashboard.css";
import ScrollContainer from "react-indiana-drag-scroll";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import { IoMdPlay } from "react-icons/io";
import "../Components/CSS/RaceCardCSS/racecard.css";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Moment from "react-moment";
import { fetchSireHistoryForStatisitics } from "../redux/getReducer/getSireHistoryForStatisitics";
import { fetchSireSnippets } from "../redux/getReducer/getSireSnippets";
import Select from "react-select";
// import { fetchResultYearFilterForStats } from "../redux/getStatsFilterReduce/getResultYearFilterForStats";
import { fetchRaceTypeFilterForStats } from "../redux/getStatsFilterReduce/getRaceTypeFilterForStats";
import { fetchTrackLengthFilterForStats } from "../redux/getStatsFilterReduce/getTrackLengthFilterForStats";
import { fetchHorseKindFilterForStats } from "../redux/getStatsFilterReduce/getHorseKindFilterForStats";
import { fetchRaceKindFilterForStats } from "../redux/getStatsFilterReduce/getRaceKindFilterForStats";
import { fetchRaceNationalityFilterForStats } from "../redux/getStatsFilterReduce/getRaceNationalityFilterForStats";
import { fetchRaceCourseFilterForStats } from "../redux/getStatsFilterReduce/getRaceCourseFilterForStats";
import { fetchDatesFilterForStats } from "../redux/getStatsFilterReduce/getDatesFilterForStats";
import { fetchGroundTypeFilterForStats } from "../redux/getStatsFilterReduce/getGroundTypeFilterForStats";
import PleaseWait from "../Components/Reuseable/PleaseWait";
import arrow1 from "../assets/image 13 (Traced).png";
import { truncateRaceType, formatDateStandard, toTitleCase } from "../service/stringUtils";
import Pagination from "./Pagination";
import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import HorseModal from "../Components/Modal/HorseModal";
import JockeyModal from "../Components/Modal/JockeyModal";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import VideoFrame from "../Components/Modal/VideoFrame.js";
import RaceModal from "../Components/Modal/RaceModal.js";
import NoHistory from "../Components/Reuseable/NoHistory.jsx";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

export default function Horsestatistics() {
  const { data: SireSnippets, status } = useSelector((state) => state.SireSnippets);
  const { data: ResultYearFilterForStats } = useSelector((state) => state.ResultYearFilterForStats);
  const { data: RaceTypeFilterForStats } = useSelector((state) => state.RaceTypeFilterForStats);
  const { data: TrackLengthFilterForStats } = useSelector((state) => state.TrackLengthFilterForStats);
  const { data: HorseKindFilterForStats } = useSelector((state) => state.HorseKindFilterForStats);
  const { data: RaceKindFilterForStats } = useSelector((state) => state.RaceKindFilterForStats);
  const { data: RaceNationalityFilterForStats } = useSelector((state) => state.RaceNationalityFilterForStats);
  const { data: RaceCourseFilterForStats } = useSelector((state) => state.RaceCourseFilterForStats);
  const { data: GroundTypeFilterForStats } = useSelector((state) => state.GroundTypeFilterForStats);
  const { data: SireHistoryForStatisitics } = useSelector((state) => state.SireHistoryForStatisitics);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  // Modals logic preserved
  const [show, setShow] = useState(false);
  const [modaldata, setmodaldata] = useState();
  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    const id = data?._id || data;
    if (id) navigate("/horse-detail?" + id);
  };

  const [shows, setShows] = useState(false);
  const [modaldatas, setmodaldatas] = useState();
  const handleCloses = () => setShows(false);
  const handleShows = async (data) => { setmodaldatas(data); setShows(true); };

  const [showJockey, setShowJockey] = useState(false);
  const [modaldataJockey, setmodaldataJockey] = useState();
  const handleCloseJockey = () => setShowJockey(false);
  const handleShowJockey = (data) => { const id = data?._id || data; if (id) navigate("/jockey-detail?" + id); };

  const [showRace, setShowRace] = useState(false);
  const [modaldataRace, setmodaldataRace] = useState();
  const handleCloseRace = () => setShowRace(false);
  const handleShowRace = (data) => { const id = data?._id || data; if (id) navigate("/race-detail?" + id); };

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(11);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [ResultYearData, setResultYearData] = useState("");
  const [ResultRaceCourseData, setResultRaceCourse] = useState("");
  const [ResultRaceTypeData, setResultRaceType] = useState("");
  const [ResultNationalityData, setResultNationality] = useState("");
  const [ResultRaceTracklengthData, setResultRaceTracklength] = useState("");
  const [ResultGroundData, setResultGround] = useState("");
  const [ResultRaceKindData, setResultRaceKind] = useState("");
  const [ResultHorseKindData, setResultHorseKind] = useState("");
  const [SireNameSearch, setSireNameSearch] = useState("");

  const [StartDate, setStartDate] = useState(moment().subtract(179, "days").format("YYYY-MM-DD"));
  const [EndDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const handleDateChange = (dates, dateStrings) => {
    if (!dates || !dateStrings) {
      setStartDate("");
      setEndDate("");
      return;
    }
    setStartDate(dateStrings[0]);
    setEndDate(dateStrings[1]);
  };

  const [compIndex, setCompIndex] = useState();

  // Derived filters logic
  let RaceCourseSearch = ResultRaceCourseData?.id || "";
  let HorseKindSearch = ResultHorseKindData?.id || "";
  let TrackLengthSearch = ResultRaceTracklengthData?.id || "";
  let RaceTypeSearch = ResultRaceTypeData?.id || "";
  let RaceKindSearch = ResultRaceKindData?.id || "";
  let RaceNationalitySearch = ResultNationalityData?.id || "";
  let RaceGroundSearch = ResultGroundData?.id || "";

  let year = ResultYearData?.id;
  let Nationality = ResultNationalityData?.id;
  let RaceCourse = ResultRaceCourseData?.id;
  let GroundType = ResultGroundData?.id;
  let RaceKind = ResultRaceKindData?.id;
  let HorseKind = ResultHorseKindData?.id;
  let RaceType = ResultRaceTypeData?.id;
  let TrackLength = ResultRaceTracklengthData?.id;

  useEffect(() => {
    const selectedYear = ResultYearData?.id;
    if (!selectedYear) {
      setStartDate(moment().subtract(179, "days").format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
      return;
    }

    const startOfYear = moment(`${selectedYear}-01-01`, "YYYY-MM-DD");
    const endOfYear = moment(`${selectedYear}-12-31`, "YYYY-MM-DD");
    const today = moment();

    let start = startOfYear;
    let end = endOfYear.isAfter(today, "day") ? today : endOfYear;

    // If someone picks a year fully in the future, keep a valid range.
    if (end.isBefore(start, "day")) start = end.clone();

    setStartDate(start.format("YYYY-MM-DD"));
    setEndDate(end.format("YYYY-MM-DD"));
  }, [ResultYearData]);

  useEffect(() => {
    dispatch(fetchSireSnippets({ StartDate, EndDate, RaceCourseSearch, HorseKindSearch, TrackLengthSearch, RaceTypeSearch, RaceKindSearch, RaceGroundSearch, RaceNationalitySearch, currentPage }));
  }, [StartDate, EndDate, RaceCourseSearch, HorseKindSearch, TrackLengthSearch, RaceTypeSearch, RaceKindSearch, RaceGroundSearch, RaceNationalitySearch, currentPage, dispatch]);

  useEffect(() => {
    // dispatch(fetchResultYearFilterForStats({ year, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceTypeFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchTrackLengthFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchHorseKindFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceKindFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceNationalityFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchRaceCourseFilterForStats({ StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    // dispatch(fetchDatesFilterForStats({ year, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
    dispatch(fetchGroundTypeFilterForStats({ StartDate, EndDate, year, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
  }, [dispatch, StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength]);

  const handleTrainerRecord = async (id, index) => {
    if (compIndex === index) { setCompIndex(null); return; }
    setCompIndex(index);
    await dispatch(fetchSireHistoryForStatisitics({ id, StartDate, EndDate, Nationality, RaceCourse, GroundType, RaceKind, HorseKind, RaceType, TrackLength }));
  };

  function distanceLabel(distance, rank) {
    const d = parseFloat(distance);
    if (d.toFixed(2) > 25) return "Dist";
    if (d.toFixed(2) === "0.05" && rank < 80) return "SHd";
    if (d.toFixed(2) === "0.10" && rank < 80) return "Hd";
    if (d.toFixed(2) === "0.25" && rank < 80) return "Nk";
    if (d.toFixed(2) === "0.01" && rank < 80) return "Ns";
    if (d.toFixed(2) === "0.00" && rank < 80) return rank === 1 ? 0 : "Dh";
    return distance;
  }

  // Dropdown mapping logic

  let RaceTypeDropdown = RaceTypeFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let TrackLengthDropdown = TrackLengthFilterForStats.map(item => ({ id: item._id, value: item.TrackLength, label: item.TrackLength }));
  let HorseKindDropdown = HorseKindFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let RaceKindDropdown = RaceKindFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));
  let NationalityDropdown = RaceNationalityFilterForStats?.map(item => ({ id: item?.NationalityDataRaceCourse?._id, value: cookiedata === "en" ? item?.NationalityDataRaceCourse?.NameEn : item?.NationalityDataRaceCourse?.NameAr, label: cookiedata === "en" ? item?.NationalityDataRaceCourse?.NameEn : item?.NationalityDataRaceCourse?.NameAr }));
  let RaceCourseDropdown = RaceCourseFilterForStats.map(item => ({ id: item._id, value: cookiedata === "en" ? item.TrackNameEn : item.TrackNameAr, label: cookiedata === "en" ? item.TrackNameEn : item.TrackNameAr }));
  let GroundTypeDropdown = GroundTypeFilterForStats?.map(item => ({ id: item._id, value: cookiedata === "en" ? item.NameEn : item.NameAr, label: cookiedata === "en" ? item.NameEn : item.NameAr }));

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: '#0c1a3e',
      border: 'none',
      borderRadius: '8px',
      minHeight: '44px',
      color: 'white',
      marginBottom: '0',
      cursor: 'pointer',
      boxShadow: 'none'
    }),
    singleValue: (provided) => ({ ...provided, color: 'white' }),
    placeholder: (provided) => ({ ...provided, color: '#9da7be', fontSize: '13px' }),
    dropdownIndicator: (provided) => ({ ...provided, color: 'white' }),
    indicatorSeparator: () => ({ display: 'none' }),
    clearIndicator: (provided) => ({ ...provided, color: '#fff', padding: '0 8px' }),
    valueContainer: (provided) => ({ ...provided, padding: '2px 8px', overflow: 'hidden' }),
    input: (provided) => ({ ...provided, margin: 0, padding: 0, opacity: 0 }),
    menu: (provided) => ({ ...provided, backgroundColor: '#0c1a3e', zIndex: 9999 }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isFocused ? '#2173d1' : '#0c1a3e', color: 'white', fontSize: '13px', cursor: 'pointer' })
  };

  return (
    <Fragment>
      <div className="sire-snippet-responsive-wrapper">
        <div className="new-stats-page-wrapper">
          <div className="common-page-banner"><h1>{t("Sire Snippets")}</h1></div>

          <div className="new-main-card-container">
            <div className="new-filter-card">
              <div className="new-dropdown-row">
                <div className="new-range-item">
                  <style>{`.sire-snippet-responsive-wrapper .new-custom-range-picker input::placeholder { color: #9da7be !important; -webkit-text-fill-color: #9da7be !important; opacity: 1 !important; }`}</style>
                  <RangePicker
                    value={[
                      StartDate ? dayjs(StartDate, "YYYY-MM-DD") : null,
                      EndDate ? dayjs(EndDate, "YYYY-MM-DD") : null,
                    ]}
                    onChange={handleDateChange}
                    format="YYYY-MM-DD"
                    className="new-custom-range-picker"
                    placeholder={[t("Start Date"), t("End Date")]}
                    separator={<span style={{ color: "#9da7be" }}>To</span>}
                    allowClear
                  />
                </div>
                <Select styles={customSelectStyles} placeholder={t("Nationality")} options={NationalityDropdown} onChange={setResultNationality} className="new-flex-select" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Race course")} options={RaceCourseDropdown} onChange={setResultRaceCourse} className="new-flex-select" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Ground Type")} options={GroundTypeDropdown} onChange={setResultGround} className="new-flex-select" isClearable />
              </div>

              <div className="new-search-date-row">
                <Select styles={customSelectStyles} placeholder={t("Race Kind")} options={RaceKindDropdown} onChange={setResultRaceKind} className="new-flex-select" isClearable />
                <Select styles={customSelectStyles} placeholder={t("KindOfHorse")} options={HorseKindDropdown} onChange={setResultHorseKind} className="new-flex-select" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Track length")} options={TrackLengthDropdown} onChange={setResultRaceTracklength} className="new-flex-select" isClearable />
                <Select styles={customSelectStyles} placeholder={t("Race type")} options={RaceTypeDropdown} onChange={setResultRaceType} className="new-flex-select" isClearable />
              </div>
            </div>

            <div className="new-stats-table-box">
              {status === "idle" ? (
                <>
                  <div className="sire-table-x-scroll-wrapper">
                    <div className="new-table-head">
                      <div>{window.textTransform(t("Sire Name"))}</div><div>{window.textTransform(t("Runs"))}</div><div>{window.textTransform(t("Wins"))}</div><div>{window.textTransform(t("Second"))}</div><div>{window.textTransform(t("Third"))}</div><div>{window.textTransform(t("Fourth"))}</div><div>{window.textTransform(t("Fifth"))}</div><div>{window.textTransform(t("Earning"))}</div><div>{window.textTransform(t("Wins"))}%</div><div>{window.textTransform(t("Place"))}%</div><div></div>
                    </div>

                    {SireSnippets?.data?.map((item, i) => (
                      <Accordion key={i} className="new-accordion-wrapper">
                        <Accordion.Item eventKey={i} className="new-acc-item" onClick={() => handleTrainerRecord(item.HorseSire, i)}>
                          <Accordion.Header className="new-acc-header-custom">
                            <div className="new-acc-header-grid">
                              <div className="new-sire-name-clickable" onClick={(e) => { e.stopPropagation(); handleShow(item.HorseSire); }}>
                                {cookiedata === "en" ? window.textTransform(item.HorseSireData.NameEn) : item.HorseSireData.NameAr}
                              </div>
                              <div>{item.HorseSireData.Runs}</div><div>{item.HorseSireData.wins}</div><div>{item.HorseSireData.second}</div><div>{item.HorseSireData.third}</div><div>{item.HorseSireData.fourth}</div><div>{item.HorseSireData.fifth}</div><div className="new-bold-text">{t("AED")} {Number(item.HorseSireData.earning).toLocaleString()}</div><div>{Number(item.HorseSireData.winspercentage || 0).toFixed(2)}</div><div>{Number(item.HorseSireData.placespercentage || 0).toFixed(2)}</div><div style={{ textAlign: 'right' }}>{compIndex === i ? <MdKeyboardArrowDown className="new-acc-arrow-icon" /> : <MdKeyboardArrowRight className="new-acc-arrow-icon" />}</div>
                            </div>
                          </Accordion.Header>

                          {compIndex === i && (
                            <Accordion.Body style={{ padding: 0 }}>
                              <ScrollContainer>
                                <div className="new-inner-grid-table">
                                  <div className="new-inner-grid-header">
                                    <div>{window.textTransform(t("Date"))}</div><div>{window.textTransform(t("Crs"))}</div><div>{window.textTransform(t("Horse Name"))}</div><div>{window.textTransform(t("Dist"))}</div><div>{window.textTransform(t("RT"))}</div><div>{window.textTransform(t("Time"))}</div><div>{window.textTransform(t("Jockey"))}</div><div>{window.textTransform(t("Wgt"))}</div><div>{window.textTransform(t("FP"))}</div><div>{window.textTransform(t("Len"))}</div><div>{window.textTransform(t("RN"))}</div><div>{window.textTransform(t("BtBy"))}</div><div>{window.textTransform(t("Kgs"))}</div><div>{window.textTransform(t("Draw"))}</div><div>{window.textTransform(t("OR"))}</div><div></div>
                                  </div>

                                  <div className="new-inner-grid-body">
                                    {!SireHistoryForStatisitics || SireHistoryForStatisitics.length === 0 ? <NoHistory /> : (
                                      SireHistoryForStatisitics.map((inner, idx) => {
                                        const groundName = inner.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                                        return (
                                          <div key={idx} className={`new-inner-card-row ${groundName === "Dirt" ? 'row-dirt' : groundName === "Turf" ? 'row-turf' : 'row-default'}`}>
                                            <div onClick={() => handleShowRace(inner.RaceID)} className="new-link-text">{formatDateStandard(inner.RaceResultData?.Day)}</div>
                                            <div>{cookiedata === "en" ? inner.RaceResultData?.RaceCourseData?.AbbrevEn : inner.RaceResultData?.RaceCourseData?.AbbrevAr}({inner.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn?.charAt(0)})</div>
                                            <div onClick={() => handleShow(inner.HorseIDData?._id)} className="new-link-text">
                                              {cookiedata === "en" ? toTitleCase(inner.HorseIDData?.NameEn) : inner.HorseIDData?.NameAr}
                                            </div>
                                            <div>{inner.RaceResultData?.TrackLengthData?.TrackLength}</div>
                                            <div>
                                              {cookiedata === "en"
                                                ? toTitleCase(truncateRaceType(inner.RaceResultData?.RaceTypeModelData?.NameEn))
                                                : inner.RaceResultData?.RaceTypeModelData?.NameAr}
                                            </div>
                                            <div>{inner.RaceTime}</div>
                                            <div onClick={() => handleShowJockey(inner.JockeyOnRaceDataResult?._id)} className="new-link-text">
                                              {cookiedata === "en" ? toTitleCase(inner.JockeyOnRaceDataResult?.NameEn) : inner.JockeyOnRaceDataResult?.NameAr}
                                            </div>
                                            <div>{inner.JockeyRaceWeight || 0}</div>
                                            <div>{cookiedata === "en" ? inner.FinalPositionDataHorse?.NameEn : inner.FinalPositionDataHorse?.NameAr}</div>
                                            <div>{distanceLabel(inner.Distance, inner.FinalPositionDataHorse?.Rank)}</div>
                                            <div>{inner.Runners}</div>
                                            <div onClick={() => handleShow(inner.BeatenByData?._id)} className="new-link-text">
                                              {inner.BeatenByData
                                                ? (cookiedata === "en" ? toTitleCase(inner.BeatenByData.NameEn) : inner.BeatenByData.NameAr)
                                                : (cookiedata === "en" ? toTitleCase(inner.HorseIDData?.HorseBeatenByEnglishName) : inner.HorseIDData?.HorseBeatenByArabicName)}
                                            </div>
                                            <div>{inner.BeatenByData ? inner.BeatenByData.WinningHorseJockeyWeight : (inner.HorseIDData?.BeatenByJockeyWeight || 0)}</div>
                                            <div>{inner.HorseNo || "-"}</div>
                                            <div>{inner.Rating || 0}</div>
                                            <div className="my-new-play-btn" onClick={(e) => { e.stopPropagation(); handleShows(inner.VideoLink); }}><IoMdPlay /></div>
                                          </div>
                                        );
                                      })
                                    )}
                                  </div>
                                </div>
                              </ScrollContainer>
                            </Accordion.Body>
                          )}
                        </Accordion.Item>
                      </Accordion>
                    ))}
                  </div>
                  <div className="new-pagination-wrapper">
                    <Pagination postsPerPage={postsPerPage} totalPosts={SireSnippets?.totalcount} paginate={paginate} currentPage={currentPage} TotalPages={SireSnippets?.totalPages} />
                  </div>
                </>
              ) : (
                <div className="new-loader-box"><Lottie animationData={Animate} style={{ width: '100px', margin: '0 auto' }} /></div>
              )}
            </div>
          </div>

          {/* MODALS */}
          <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
          <Modal show={show} onHide={handleClose} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><HorseModal data={modaldata} /></Modal.Body></Modal>
          <Modal show={showJockey} onHide={handleCloseJockey} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><JockeyModal data={modaldataJockey} /></Modal.Body></Modal>
          <Modal show={showRace} onHide={handleCloseRace} size="lg" centered><Modal.Header closeButton className="popupheader"></Modal.Header><Modal.Body><RaceModal id={modaldataRace} /></Modal.Body></Modal>

          <Footer /><CoptRight />
        </div>
      </div>
    </Fragment>
  );
}